import { createContext } from "react";

const CollapsibleContext = createContext({
  overrideTitleClassName: "",
  headerElement: "",
});

export default CollapsibleContext;
